import { render, staticRenderFns } from "./StickersForm.vue?vue&type=template&id=8d8b4eaa&scoped=true"
import script from "./StickersForm.vue?vue&type=script&lang=js"
export * from "./StickersForm.vue?vue&type=script&lang=js"
import style0 from "./StickersForm.vue?vue&type=style&index=0&id=8d8b4eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b4eaa",
  null
  
)

export default component.exports